module.exports = __webpack_public_path__ + "media/images/fc-picture-ab2e7f8da405e05087df6539531d1413.jpg";